import schoolClassYearMonthService from 'helpers/school-class-year-month-service'

const isWithinPromptWindow = (gradYear, hs) => {
  return schoolClassYearMonthService.isAfter(
    gradYear,
    hs.CurrentSeniorYear,
    hs.FERPA.PromptMonth,
    hs.FERPA.PromptClassYear,
  )
}
const isMissingStudentSignableRelease = (user) => {
  return user.StudentRequirements.NeedsSignedFERPARelease && !user.StudentRequirements.NeedsParentToSignFERPA
}
const isMissingStudentSignableReleaseDateAware = (user, profile) => {
  return isMissingStudentSignableRelease(user) && isWithinPromptWindow(profile.GraduationYear, user.HighSchool)
}
const isMissingParentForReleaseSigning = (user) => {
  return (
    user.StudentRequirements.NeedsSignedFERPARelease &&
    user.StudentRequirements.NeedsParentToSignFERPA &&
    user.StudentRequirements.NeedsParents
  )
}
const isMissingParentForReleaseSigningDateAware = (user, profile) => {
  return isMissingParentForReleaseSigning(user) && isWithinPromptWindow(profile.GraduationYear, user.HighSchool)
}
const isMissingWaiver = (user) => {
  return user.StudentRequirements.NeedsSignedFERPAWaiver
}
const isMissingWaiverDateAware = (user, profile) => {
  return isMissingWaiver(user) && isWithinPromptWindow(profile.GraduationYear, user.HighSchool)
}

export default {
  'FERPA-R-DATE': isMissingStudentSignableReleaseDateAware,
  'FERPA-PR-DATE': isMissingParentForReleaseSigningDateAware,
  'FERPA-W-DATE': isMissingWaiverDateAware,
  'FERPA-R': isMissingStudentSignableRelease,
  'FERPA-PR': isMissingParentForReleaseSigning,
  'FERPA-W': isMissingWaiver,
}
